import { TFunction } from "i18next";

export const getListName = (
  id: string | number,
  isDesk: boolean,
  isWork: boolean,
  t: TFunction,
) => {
  const isActions = window.location.pathname.search("actions") !== -1;
  const isCases = window.location.pathname.search("cases") !== -1;
  const isDesk_url = window.location.pathname.search("desk") !== -1;
  const isClients = window.location.pathname.search("clients") !== -1;
  const isTemplates = window.location.pathname.search("templates") !== -1;
  const isPisma = window.location.pathname.search("pisma") !== -1;

  if (isPisma) return t("desk.letters");
  if (isCases) return t("sidebar.cases");
  if (isActions) return t("actions.title");
  if (isDesk || isDesk_url) return t("sidebar.desk");
  if (isWork) return t("sidebar.drafts");
  if (isClients) return t("sidebar.entities");
  if (isTemplates) return t("settings.templates");

  switch (id) {
    case 0:
      return "";
    case 1:
      return t("sidebar.incoming");
    case 2:
    case 10:
      return t("sidebar.outgoing");
    default:
      return t("sidebar.incoming");
  }
};
